import React from 'react';
import { Client } from '../../prismic-configuration';
import Prismic from '@prismicio/client';
import { PageWrapper } from '../../components/base';
import { PrismicAward } from '../../types/prismic';
import {
  AwardCallToAction,
  AwardDonations,
  AwardFaq,
} from '../../components/award';
import {
  GrantAbout,
  GrantEligibility,
  GrantProcess,
  LandingHeader,
  ProgramCurriculum,
} from '../../components/grant';

interface Props {
  doc: PrismicAward;
  slugs: string[];
}

/* TODO: add a separate field long-term for page title, header_label isn't awesome for this */
const GrantDreamMakersPage = ({ doc, slugs }: Props) => {
  const onlyBaseAward = slugs.length === 1;
  const hasProgram = doc.data.program_enabled;
  const showProcessCta = !hasProgram;
  return (
    <PageWrapper title={doc.data.header_label}>
      <LandingHeader data={doc.data} partner_image_size="lg" />
      {onlyBaseAward ? (
        <>
          <AwardCallToAction data={doc.data} />
          <GrantEligibility data={doc.data} />
          <section className="full-width column center">
            <GrantProcess data={doc.data} showProcessCta={showProcessCta} />
            {hasProgram ? (
              <>
                <ProgramCurriculum data={doc.data} />
              </>
            ) : null}
          </section>
        </>
      ) : (
        <>
          <AwardFaq data={doc.data} showAngle={false} />
        </>
      )}
      <GrantAbout data={doc.data} />
      <AwardDonations data={doc.data} />
    </PageWrapper>
  );
};

export async function getServerSideProps({ query }) {
  console.log('query', query.slug);
  const client = Client();
  const doc = await client.queryFirst([
    Prismic.Predicates.at('document.type', 'award'),
    Prismic.Predicates.at('my.award.url_slug', 'award-' + query.slug[0]),
  ]);

  return {
    props: {
      doc,
      slugs: query.slug,
    },
  };
}

export default GrantDreamMakersPage;
